import { FileTextIcon, DownloadIcon, ActivityIcon, SmartphoneIcon } from 'lucide-react';

export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/8d2Km6uK3YbCyE8xs73iAT/Coleccion_de_Guias_de_Triatlon_SIGMA_SMART.webp';

export const heroChips = [
  { icon: FileTextIcon, label: 'Görsel PDF formatı' },
  { icon: DownloadIcon, label: 'Anında dijital erişim' },
  { icon: ActivityIcon, label: 'Farklı antrenman seviyelerine uygun yapı' },
  { icon: SmartphoneIcon, label: 'Telefon, tablet ve bilgisayardan erişim' },
];

export const disciplines = ['Yüzme', 'Bisiklet', 'Koşu', 'Beslenme', 'İlerleme takibi', 'Yarış günü uygulaması'];
